import Marquee3K from 'marquee3000';


$(document).ready(function () {
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
    // if reduced motion not set, allow the animation
    if (!isReduced) {
        $('.marquee-one').attr('data-speed', '0.35');
        $('.marquee-two').attr('data-speed', '0.25');
    }

    Marquee3K.init();
})
